import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M14.06 9.865l.92.92-9.06 9.06H5v-.92l9.06-9.06zm3.6-6.02c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83a.996.996 0 000-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 18.095v3.75h3.75l11.06-11.06-3.75-3.75z" fill="#07A" /></svg>;